import { SemesterResult } from '../../../shared/models/api-results/semester.api-result';
import {
  ListStudentSettingsResult,
  StudentSettingResult,
} from '../../../shared/models/api-results/student-setting.api-result';
import { StudentResult } from '../../../shared/models/api-results/student.api-result';
import { ListSubscriptionsResult } from '../../../shared/models/api-results/subscription.api-result';
import { UniversityResult } from '../../../shared/models/api-results/university.api-result';
import { WriterResult } from '../../../shared/models/api-results/writer.api-result';
import { Semester } from '../../../shared/models/entities/semester.entity';
import { University } from '../../../shared/models/entities/university.entity';
import { CallState, LoadingState } from '../../../shared/models/interfaces/call-state.interface';
import { LocaleKeys } from '../../../shared/utils/locale-keys';

export interface AuthState {
  initializing: boolean;
  refreshingToken: boolean;
  student: StudentResult;
  studentSettings: ListStudentSettingsResult;
  activeSubscriptions: ListSubscriptionsResult;
  writer: WriterResult;
  currentPassWriterUniversityId: string;
  currentPassWriterSemesterId: string;

  loginState: CallState;
  pathToReachAfterLogin: string;

  isInMaintenance: boolean;

  impersonateUser: StudentResult;
}

export const initialAuthState: AuthState = {
  initializing: true,
  refreshingToken: false,
  student: undefined,
  studentSettings: undefined,
  activeSubscriptions: undefined,
  writer: undefined,
  currentPassWriterUniversityId: undefined,
  currentPassWriterSemesterId: undefined,

  loginState: LoadingState.INIT,
  pathToReachAfterLogin: undefined,

  isInMaintenance: false,

  impersonateUser: undefined,
};
